import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import FigureCover from "../FigureCover";
// import SanityImage from "../SanityImage";
import trame from "../../images/trame.svg";

const PC5 = ({ input }) => (
  <div className='template5'>
    <div
      className='grid h-screen'
      style={{
        // display: "grid",
        // gridRowGap: "10px",
        gridTemplateColumns: "20% 1fr 1fr 1fr 1fr",
        gridTemplateRows: "1fr 200px",
        gridTemplateAreas: `'deco1 image1 image1 image1 image1'
                            'image2 image2 image2 image2 white'`
        // background: `url(${trame})`
      }}>
      <div
        className='deco '
        style={{
          gridArea: "deco1",
          background: `url(${trame})`
        }}>
        {/* <StaticImage
          src={"../../images/template5-graphique-1.svg"}
          alt='template1 graphique'
          className='w-full h-full'
          placeholder='blurred'
        /> */}
        <div className='flex h-full'>
          <div
            className='bg-key mr-md flex-shrink-0'
            style={{ width: "40px", backgroundcolor: "#000000" }}></div>
          <div
            className='bg-gray-300 mr-md flex-shrink-0'
            style={{ width: "30px", backgroundcolor: "#575756" }}></div>
          <div
            className='bg-gray-200 mr-md flex-shrink-0'
            style={{ width: "20px", backgroundcolor: "#878787" }}></div>
          <div
            className='bg-gray-100 mr-md flex-shrink-0'
            style={{ width: "10px", backgroundcolor: "#B2B2B2" }}></div>
        </div>
      </div>

      <div className='image1 ' style={{ gridArea: "image1" }}>
        <FigureCover input={input[0]} />
      </div>

      <div
        className='image2 '
        style={{
          gridArea: "image2",
          paddingTop: "10px",
          background: `url(${trame})`
        }}>
        <div className='flex h-full'>
          <div
            style={{
              maxWidth: "calc(100% - 50px)",
              flexShrink: 0
            }}
            className='h-full'>
            <FigureCover input={input[0]} />
          </div>
          <div
            style={{
              width: "50px",
              flexShrink: 0
            }}
            className='h-full bg-white'>
            <StaticImage
              src={"../../images/template5-graphique-3.svg"}
              alt='template1 graphique'
              className='h-full'
              placeholder='blurred'
            />
          </div>
        </div>
      </div>
      <div
        className='white '
        style={{ gridArea: "white", backgroundColor: "white" }}></div>
    </div>
  </div>
);

export default PC5;
